import update from 'immutability-helper'
import { AnyAction } from 'redux'
import * as type from '@app/constants/myEnergy/billingPeriod'

export interface IBillingPeriodsStatsState {
  billing_periods: any[],
}

export const initialState: IBillingPeriodsStatsState = {
  billing_periods: [],
}

const billingPeriodsStats = (
  state: IBillingPeriodsStatsState = initialState,
  action: AnyAction,
): IBillingPeriodsStatsState => {
  switch (action.type) {
  case type.UPDATE_BILLING_PERIODS_STATS:
    return update(state, {
      billing_periods: { $set: action.stats },
    })
  case type.RESET_ALL_BILLING_PERIODS:
    return { ...state, billing_periods: initialState.billing_periods }
  default:
    return state
  }
}

export default billingPeriodsStats
